<template>
  <div class="panel-attention panel-attention-orange">
    <p>{{ title }}</p>
    <kcs-btn
      :url="url"
      :external="true"
      @click.native="
        handleAnalyticsTrackEvent('facility_detail', 'click', 'event_regist', 1)
      "
      name="イベントの登録"
    />
  </div>
</template>

<script>
import KcsBtn from '@/components/atoms/kcs-btn.vue'
export default {
  components: {
    KcsBtn
  },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      return (
        this.detail.name +
        'のイベントを「こくちーずプロ」に登録してセミナー・イベントの告知及び集客をする'
      )
    },
    url() {
      return 'https://www.kokuchpro.com/regist/?fcd=' + this.detail.code
    }
  }
}
</script>
